var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t('create_a_product')))]),_c('product-form',{on:{"saved":function($event){return _vm.productCreated($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }